import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import * as XLSX from "xlsx";
import QRCodeLib from "qrcode";
import {
  Box,
  Toolbar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Loading } from "../../components";
import {
  getCards,
  handleGetAllCards,
  handleNewCardsCreate,
} from "../../api-services/superAdmin";
import { apiRequestStatuses } from "../../common/constant/index";
import { exportCardsWithQR } from "../../utils/common";
import { useDispatch } from "react-redux";
import { notification } from "../../redux/slices/authSlice";
import {
  Edit as EditIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Circle as CircleIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";

const CardInfo = () => {
  const dispatch = useDispatch();

  const [Cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [Card, setCard] = useState({
    cardNo: "",
    id: "",
    scanUrl: "",
    startNo: "",
    endNo: "",
    type: "",
  });
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paginationn, setPagination] = useState({
    currentPage: 0,
    limit: 0, // Rows per page
    totalPages: 0,
    totalRecords: 0,
  });

  const fetchCards = async (name, page) => {
    try {
      if (!name) name = "";
      const response = await getCards(name, page);

      const { cards, pagination } = response.payload.data;
      setCards(cards);
      setPagination({
        currentPage: pagination.currentPage,
        limit: pagination.limit,
        totalRecords: pagination.totalRecords,
        totalPages: pagination.totalPages,
      });
    } catch (err) {
      console.error("Error fetching Cards:", err); // Log error for debugging
      setError("Error loading Cards. Please try again later."); // Set user-friendly error message
    } finally {
      setLoading(false); // Move loading state update here
    }
  };

  // Fetch Cards from the backend
  useEffect(() => {
    fetchCards();
  }, []);

  const handleClickOpen = (card = { type: "add", id: null, name: "" }) => {
    setOpen(true);

    // Save the action type (add/download)
    setCard({
      type: card?.type || "add",
      id: card?._id || null,
      cardNo: card?.cardNo || "",
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCard((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let res = await handleNewCardsCreate(Card.startNo, Card.endNo, true);

    if (res.metadata.status === apiRequestStatuses.SUCCESS) {
      fetchCards();

      dispatch(
        notification({
          open: true,
          type: "success",
          message: `New url's for card created successfully!`,
        })
      );
    }

    setOpen(false);
  };

  const handleExport = async (e) => {
    e.preventDefault();

    let res = await handleGetAllCards(Card.startNo, Card.endNo);

    const { cards } = res.payload.data;

    try {
      // Just call your helper function
      await exportCardsWithQR(cards, Card.startNo, Card.endNo);
    } catch (error) {
      console.error("Export error:", error);
    }

    setOpen(false);
  };

  const handlePageChange = async (event, newPage) => {
    setPagination((prevState) => ({
      ...prevState,
      currentPage: newPage,
    }));

    await fetchCards(searchTerm, newPage);
  };

  const handleSearchChange = async (event) => {
    const name = event.target.value;
    setSearchTerm(name);

    fetchCards(name);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (loading) {
    return <Loading />; // Show loading spinner
  }

  if (error) {
    return <Typography variant="body1">{error}</Typography>; // Show error message
  }

  return (
    <Box
      component="main"
      sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
    >
      <Toolbar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Card List
        </Typography>

        <TextField
          variant="outlined"
          placeholder="Search by Card No"
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{
            marginBottom: "20px",
            width: "40%",
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px", // Rounded corners
            },
          }}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <AddIcon
            sx={{
              color: "aliceblue",
              cursor: "pointer",
              background: "linear-gradient(90deg, #001F54, #9B2ECA)",
            }}
            onClick={() => handleClickOpen({ id: null, name: "", type: "add" })}
          />

          <DownloadIcon
            sx={{
              color: "aliceblue",
              cursor: "pointer",
              background: "linear-gradient(90deg, #001F54, #9B2ECA)",
            }}
            onClick={() =>
              handleClickOpen({ id: null, name: "", type: "download" })
            }
          />
        </Box>
      </Box>

      {Cards.length > 0 ? (
        <>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="organisations table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Card No</TableCell>
                  {/* <TableCell sx={{ fontWeight: "bold" }}>UniqueId</TableCell> */}
                  <TableCell sx={{ fontWeight: "bold" }}>Url</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Qr-Code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Cards.map((card) => (
                  <TableRow key={card?._id} hover style={{ cursor: "pointer" }}>
                    <TableCell>{card?.cardNo || "-"}</TableCell>
                    {/* <TableCell> {card?.uniqueId}</TableCell> */}
                    <TableCell> {card?.scanUrl}</TableCell>
                    <TableCell>
                      {card?.scanUrl ? (
                        <QRCode
                          value={card.scanUrl}
                          size={64}
                          style={{
                            height: "auto",
                            maxWidth: "100%",
                            width: "64px",
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination
            count={paginationn.totalPages} // Total number of pages
            page={paginationn.currentPage} // Current page
            onChange={handlePageChange} // Handle page change
            sx={{ mt: 2, display: "flex", justifyContent: "center" }} // Styling for pagination
          />
        </>
      ) : (
        <Typography variant="body1">No Cards found.</Typography>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          sx: { width: "600px" },
        }}
      >
        <DialogTitle>Cards</DialogTitle>
        <DialogContent
          style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <TextField
              autoFocus
              required
              margin="dense"
              id="startNo"
              name="startNo"
              label="Card Start No"
              value={Card.startNo}
              onChange={handleChange}
              style={{ width: "48%" }}
              variant="standard"
            />
            <TextField
              autoFocus
              margin="dense"
              id="endNo"
              name="endNo"
              label="Card End No"
              value={Card.endNo}
              onChange={handleChange}
              style={{ width: "48%" }}
              variant="standard"
            />
          </div>
        </DialogContent>
        <DialogActions>
          {Card?.type === "download" ? (
            <Button type="submit" onClick={handleExport}>
              Export
            </Button>
          ) : (
            <Button type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CardInfo;
